(() => {
  const nav = document.querySelector('.alb-shop-nav');
  if (!nav) return;

  const menus = Array.from(nav.querySelectorAll('.site-nav__details[data-hover="true"]'));
  const closeTimers = new WeakMap();

  function cancelClose(menu) {
    clearTimeout(closeTimers.get(menu));
  }

  function closeMenu(menu) {
    cancelClose(menu);
    menu.removeAttribute('open');
    menu.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  menus.forEach(menu => {
    const summary = menu.querySelector('summary');

    summary.addEventListener('mouseenter', () => {
      menus.forEach(other => {
        if (other !== menu) closeMenu(other);
      });
    });

    menu.addEventListener('mouseenter', () => cancelClose(menu), true);
    menu.addEventListener('focusin', () => cancelClose(menu), true);

    // The theme normally closes the menu as soon as the pointer leaves its label.
    // Keep it open while the pointer crosses the space below the header.
    menu.addEventListener('mouseleave', event => {
      event.stopImmediatePropagation();
      cancelClose(menu);
      closeTimers.set(menu, setTimeout(() => {
        if (!menu.matches(':hover') && !menu.matches(':focus-within')) closeMenu(menu);
      }, 160));
    }, true);
  });

  const drawer = document.getElementById('NavDrawer');
  if (!drawer) return;

  const drawerScroll = drawer.querySelector('.drawer__scrollable');
  let touchStartY = null;
  let rubberBandOffset = 0;
  const resetRubberBand = () => {
    if (!rubberBandOffset) return;
    drawerScroll.style.transition = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'none'
      : 'transform 240ms cubic-bezier(.2, .8, .2, 1)';
    drawerScroll.style.transform = '';
    rubberBandOffset = 0;
  };

  drawerScroll.addEventListener('touchstart', event => {
    if (event.touches.length !== 1 || drawerScroll.scrollHeight > drawerScroll.clientHeight + 1) return;
    touchStartY = event.touches[0].clientY;
    drawerScroll.style.transition = 'none';
  }, { passive: true });

  drawerScroll.addEventListener('touchmove', event => {
    if (touchStartY === null || event.touches.length !== 1) return;
    if (drawerScroll.scrollHeight > drawerScroll.clientHeight + 1) {
      touchStartY = null;
      resetRubberBand();
      return;
    }
    const distance = event.touches[0].clientY - touchStartY;
    if (Math.abs(distance) < 2) return;
    event.preventDefault();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    rubberBandOffset = Math.max(-18, Math.min(18, distance * .18));
    drawerScroll.style.transform = `translate3d(0, ${rubberBandOffset}px, 0)`;
  }, { passive: false });

  ['touchend', 'touchcancel'].forEach(type => {
    drawerScroll.addEventListener(type, () => {
      touchStartY = null;
      resetRubberBand();
    }, { passive: true });
  });

  let savedScrollY = null;
  let originalBodyStyles = null;
  const lockProperties = ['position', 'top', 'left', 'right', 'width'];
  const syncDrawerScroll = () => {
    if (drawer.classList.contains('drawer--is-open')) {
      if (savedScrollY !== null) return;
      savedScrollY = window.scrollY;
      originalBodyStyles = lockProperties.map(property => [
        property,
        document.body.style.getPropertyValue(property),
        document.body.style.getPropertyPriority(property)
      ]);
      document.body.style.setProperty('position', 'fixed', 'important');
      document.body.style.setProperty('top', `${-savedScrollY}px`, 'important');
      document.body.style.setProperty('left', '0', 'important');
      document.body.style.setProperty('right', '0', 'important');
      document.body.style.setProperty('width', '100%', 'important');
      document.documentElement.classList.add('alb-nav-scroll-lock');
    } else if (savedScrollY !== null) {
      touchStartY = null;
      resetRubberBand();
      const restoreY = savedScrollY;
      savedScrollY = null;
      document.documentElement.classList.remove('alb-nav-scroll-lock');
      originalBodyStyles.forEach(([property, value, priority]) => {
        if (value) document.body.style.setProperty(property, value, priority);
        else document.body.style.removeProperty(property);
      });
      originalBodyStyles = null;
      window.scrollTo(0, restoreY);
    }
  };

  new MutationObserver(syncDrawerScroll).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  syncDrawerScroll();
})();
